import { schoolTokenAxios } from "../axios";

const SCHOOL_BASE = process.env.REACT_APP_SCHOOL_BASE;
let school = `${SCHOOL_BASE}/school`;
let schoolSettings = `${SCHOOL_BASE}/schoolSettings`;

export const updateStatusOfLegal = (body) => {
  return schoolTokenAxios.put(`${school}/updateStatusOfLegal`, body);
};
export const updateDefaultFeeInvoice = (body) => {
  return schoolTokenAxios.put(
    `${schoolSettings}/updateDefaultFeeInvoice`,
    body
  );
};

export const getFeeReminderTemplate = (params) => {
  return schoolTokenAxios.get(`${schoolSettings}/getFeeReminderTemplate`, {
    params,
  });
};

export const getSMSTemplate = (params) => {
  return schoolTokenAxios.get(`${schoolSettings}/getSMSTemplate`, {
    params,
  });
};



// Started code by priyanshu from Here

export const getSchoolSetting = () => {
  return schoolTokenAxios.get(`${schoolSettings}/getSchoolSetting`);
};

export const getFeeSetting = (params) => {
  return schoolTokenAxios.get(`${schoolSettings}/getFeeSetting`, {
    params,
  });
}
export const getFeeCollectionTimeSetting=()=>{
  return schoolTokenAxios.get(`${schoolSettings}/getFeeCollectionTimeSetting`);
}

export const updatePromotionRule = (params) => {
  return schoolTokenAxios.put(`${schoolSettings}/updatePromotionRule`, params);
};

export const upsertFeeSetting = (params) => {
  return schoolTokenAxios.put(`${schoolSettings}/upsertFeeSetting`, params);
};

export const upsertFeeCollectionTimeSetting = (params) => {
  return schoolTokenAxios.put(`${schoolSettings}/upsertFeeCollectionTimeSetting`, params);
};
